export class EnquiyProductDetaiils{
    productId:number
    productName:string
    enquiryId:number
    category:string
    brandId:number
    brandName:string
    variantId:number
    variantCode:string
    packstyleId:number
    packstyle:string
    styleWeighment:string
    unitPrice:number
    noOfCases:number
    caseWeight:number
    netWeight:number
    netAmount:number
    noOfSkewers:number//for skewer category
    varietyId:number//size for rings and skewers
    varietyName:string//size for rings and skewers
    constructor(
        productId:number,
        productName:string,
        enquiryId:number,
        category:string,
        brandId:number,
        brandName:string,
        variantId:number,
        variantCode:string,
        packstyleId:number,
        packstyle:string,
        styleWeighment:string,
        unitPrice:number,
        noOfCases:number,
        caseWeight:number,
        netWeight:number,
        netAmount:number,
        noOfSkewers:number,//for skewer category
        varietyId:number,//size for rings and skewers
        varietyName:string//size for rings and skewers
        ){
            this.productId=productId
            this.productName=productName
            this.enquiryId=enquiryId
            this.category=category
            this.brandId=brandId
            this.brandName=brandName
            this.variantId=variantId
            this.variantCode=variantCode
            this.packstyleId=packstyleId
            this.packstyle=packstyle
            this.styleWeighment=styleWeighment
            this.noOfCases=noOfCases
            this.unitPrice=unitPrice
            this.caseWeight=caseWeight
            this.netWeight=netWeight
            this.netAmount=netAmount
            this.noOfSkewers=noOfSkewers
            this.varietyId=varietyId
            this.varietyName=varietyName


        }
}